<template>
  <div class="search-base search-container">
    <search-filter-item v-if="layout === 'filter'" ref="searchFilterItem" :label="label" @remove="onClickFilterRemove">
      <ml-input class="w-full" icon-pack="feather" icon="icon-search" :placeholder="placeholder" v-model="keyword" @change="onChangeData" @keyup.enter="onKeyup" :clearable="clearable" @clear="onClear" />
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div>
        <ml-input class="w-full xl:w-48" icon-pack="feather" icon="icon-search" :placeholder="placeholder" v-model="keyword" @change="onChangeData" @keyup.enter="onKeyup" :clearable="clearable" @clear="onClear" />
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchKeyword",
  components: {
    SearchFilterItem,
    SearchLabelBody,
  },
  emits: ["input"],
  props: {
    label: {
      default: "연도",
      type: String,
    },
    placeholder: {
      type: String,
      default: "검색어를 입력하세요.",
    },
    value: [String, Number],
    setRef: Function,
    readonly: Boolean,
    clearable: {
      type: Boolean,
      default: false,
    },
    clearAndSearch: {
      type: Boolean,
      default: true,
    },
    query: {
      type: Object,
      default: () => {
        return {
          keyword: "",
        };
      },
    },
    options: Object,
    onClickSearch: Function,
  },
  watch: {
    value(value) {
      this.keyword = value;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : "default";
    },
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    initData() {
      const defaultValue = this.options && this.options["default"] ? this.options["default"] : "";
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const keyword = query[_query_keys[0]];
      if (keyword) {
        try {
          return {
            keyword: keyword || defaultValue,
          };
        } catch (e) {
          console.error("URL 파라미터 파싱 오류:", e);
        }
      }
      return {
        keyword: defaultValue,
      };
    },
    gridTemplateColumns() {
      return this.options && this.options.gridTemplateColumns ? this.options.gridTemplateColumns : "auto auto";
    },
  },
  data() {
    return {
      keyword: "",
    };
  },
  created() {
    this.keyword = this.initData.keyword;
    this.$emit("input", this.keyword);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef("searchFilterItem", this.$refs.searchFilterItem);
    }
  },
  methods: {
    onChangeData() {
      this.$emit("input", this.keyword);
    },
    onKeyup() {
      this.onChangeData();
      if (this.onClickSearch) {
        this.onClickSearch();
      }
    },
    onClickFilterRemove() {
      this.keyword = "";
      this.onChangeData();
    },
    onClear() {
      this.keyword = "";
      this.onChangeData();

      // clearAndSearch가 true일 때만 검색 수행
      if (this.clearAndSearch && this.onClickSearch) {
        this.onClickSearch();
      }
    },
  },
};
</script>
